module.exports = __webpack_public_path__ + "static/img/page12.c95e71a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page12.jpg
// module id = Mx8h
// module chunks = 0